module.exports = __webpack_public_path__ + "static/media/Online shopping-bro-purple.e6c938de.svg";